var ActionEvent = /** @class */ (function () {
    function ActionEvent(_refresh) {
        this._refresh = _refresh;
        this._isRefreshed = false;
        this._defaultPrevented = false;
    }
    ActionEvent.prototype.preventDefault = function () {
        this._defaultPrevented = true;
    };
    ActionEvent.prototype.refresh = function () {
        this._isRefreshed = true;
        this._refresh();
    };
    Object.defineProperty(ActionEvent.prototype, "shouldRefresh", {
        get: function () {
            return !this._defaultPrevented && !this._isRefreshed;
        },
        enumerable: false,
        configurable: true
    });
    return ActionEvent;
}());
export { ActionEvent };
